export default function Section({ children, backgroundColor }) {
  return (
    <div className={`section-container ${backgroundColor}`}>
      <div className="section">{children}</div>
    </div>
  );
}
